import React from 'react'
import type { EquityFormData } from 'submission/lib/equity-form-defaults'

type Props = {
  form: EquityFormData
  setForm: React.Dispatch<React.SetStateAction<EquityFormData>>
  errors: Record<string, string>
}

const FIELDS: Array<{
  key: keyof EquityFormData
  label: string
  multiline?: boolean
}> = [
  { key: 'vehicleCompanyName', label: 'Company name' },
  { key: 'vehicleDirectorName', label: 'Director name' },
  { key: 'vehicleSignatoryName', label: 'Signatory name' },
  { key: 'vehicleSignatoryTitle', label: 'Signatory title' },
  {
    key: 'vehicleRegisteredAddress',
    label: 'Registered address',
    multiline: true,
  },
  { key: 'vehicleCompanyNo', label: 'Company number' },
]

const VehicleSection: React.FC<Props> = ({ form, setForm, errors }) => {
  return (
    <section className="bg-white border border-slate-200 rounded p-6">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">
        Equity vehicle
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {FIELDS.map((f) => (
          <label
            key={f.key}
            className={`flex flex-col text-sm ${
              f.multiline ? 'md:col-span-2' : ''
            }`}
          >
            <span className="text-slate-700 mb-1">{f.label} *</span>
            {f.multiline ? (
              <textarea
                className="border rounded px-2 py-1 text-slate-900 bg-white"
                rows={2}
                value={form[f.key] as string}
                onChange={(e) =>
                  setForm((p) => ({ ...p, [f.key]: e.target.value }))
                }
              />
            ) : (
              <input
                className="border rounded px-2 py-1 text-slate-900 bg-white"
                value={form[f.key] as string}
                onChange={(e) =>
                  setForm((p) => ({ ...p, [f.key]: e.target.value }))
                }
              />
            )}
            {errors[f.key] && (
              <span className="text-red-600 text-xs mt-1">{errors[f.key]}</span>
            )}
          </label>
        ))}
      </div>
    </section>
  )
}

export default VehicleSection
